var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { compose, margin, variant } from 'styled-system';
import { getSemanticValue } from '../../utils/cssVariables';
const sizeVariant = variant({
    prop: 'size',
    variants: {
        small: {
            width: '1rem',
            height: '1rem',
            borderWidth: '0.1rem'
        },
        medium: {
            width: '1.25rem',
            height: '1.25rem',
            borderWidth: '0.125rem'
        }
    }
});
const rotation = keyframes `
    to {
        transform: rotate(360deg);
    }
`;
const InlineSpinnerIcon = styled.span.withConfig({ displayName: "InlineSpinnerIcon", componentId: "sc-8wbt6c" }) `
    display: inline-block;
    box-sizing: border-box;
    width: 1.25rem;
    height: 1.25rem;
    vertical-align: text-bottom;
    border: 0.125rem solid ${p => p.color};
    border-right-color: transparent;
    border-radius: 50%;
    animation: ${rotation} 750ms linear infinite;

    ${compose(margin, sizeVariant)}
`;
const InlineSpinner = (_a) => {
    var { color = getSemanticValue('foreground-primary'), size = 'medium' } = _a, rest = __rest(_a, ["color", "size"]);
    return (React.createElement("span", { role: "progressbar" },
        React.createElement(InlineSpinnerIcon, Object.assign({ color: color, size: size }, rest))));
};
export { InlineSpinner };
